import React from 'react';
import { Grid, Button, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Illustration from 'components/illustration';
import { LinkProps, Link } from 'react-router-dom';
import p from 'translation';

const NextPage = React.forwardRef<any, LinkProps>((props, ref) => (
  <Link ref={ref} {...props} />
));

export default function Welcome(): JSX.Element {
  // See third example in Mui v5 docs for <Hidden>
  // https://mui.com/material-ui/migration/v5-component-changes/#hidden
  const theme = useTheme();
  const hidden = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <main>
      <Grid container spacing={5} justifyContent='center'>
        <Grid item md>
          <h1 className='welcome'>{p.t('pages.onboarding.intro.title')}</h1>
          {!hidden && <Illustration variant='groupOfPeople' />}

          <p>{p.t('pages.onboarding.intro.simple')}</p>
          <ul>
            <li>{p.t('pages.onboarding.intro.manage')}</li>
            <li>{p.t('pages.onboarding.intro.control')}</li>
            <li>{p.t('pages.onboarding.intro.tailor')}</li>
          </ul>
        </Grid>

        <Grid item md>
          <Illustration variant='groupOfPeople' />
        </Grid>
      </Grid>

      <section style={{ textAlign: 'center', marginTop: '4em' }}>
        <p>{p.t('pages.onboarding.intro.get-started')}</p>
        <Button
          variant='contained'
          color='primary'
          component={NextPage}
          to='/signup/terms-and-conditions'
        >
          {p.t('pages.onboarding.intro.verify')}
        </Button>
      </section>
    </main>
  );
}
